import React, { useState } from 'react'
import CustomTooltip from "../../Atoms/CustomTooltip";
import '../css/agent.classification.css';
import { useAgent } from '../../../contexts/AgentsContext';

const AgentClassification = ({ activeAgentData }) => {
  const [currentSkillHovered, setCurrentSkillHovered] = useState(null);

  const agentData = activeAgentData?.agent_metadata?.a2a || {};

  const industries = agentData?.industry_info?.map((info) => ({
    name: info?.industry,
    sectors: info?.sector || [],
  })) || [];

  // Get business functions
  const businessFunctions = agentData?.business_function || [];

  // Get skills
  const skills = agentData?.skills?.map(skill => skill?.name) || [];

  return (
    <>
      <div className="agent-classification-container" style={{ marginTop: "32px" }}>
        <div className="row">
          <div className="col-md-12">
            <h3 className="classification-title mb-3">
              Classification
            </h3>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="classification-details">
              <div className="classification-detail-row mb-3">
                <div className="col-md-3">
                  <span className="detail-label">Industry/Sector</span>
                </div>
                <div className="col-md-9">
                  <div className="industry-values">
                    {industries.length === 0 ? (
                      <div className="classfication-value" style={{ color: "#63666A" }}>
                        N/A
                      </div>
                    ) : (
                      industries.map((industry, idx) => (
                        <div key={idx}>
                          {industry?.name}
                          {industry?.sectors && industry.sectors.length > 0 && (
                            <> | {industry.sectors.join(", ")}</>
                          )}
                        </div>
                      ))
                    )}
                  </div>
                </div>
              </div>
              <div className="classification-detail-row mb-3">
                <div className="col-md-3">
                  <span className="detail-label">Business Function</span>
                </div>
                <div className="col-md-9">
                  <div className="business-function-values">
                    {businessFunctions.length === 0 ? (
                      <div className="classfication-value" style={{ color: "#63666A" }}>
                        N/A
                      </div>
                    ) : (
                      businessFunctions.map((func, index) => (
                        <div key={index}>
                          <span className="business-function-item">
                            {func}
                          </span>
                          {index < businessFunctions.length - 1 && (
                            <strong style={{ color: "#63666A" }}> | </strong>
                          )}
                        </div>
                      ))
                    )}
                  </div>
                </div>
              </div>
              <div className="classification-detail-row mb-3" >
                <div className="col-3">
                  <div className="detail-label">Agent Skills</div>
                </div>
                <div
                  className="col-9"
                  style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}
                >
                  {skills.length === 0 ? (
                    <div className="classfication-value" style={{ color: "#63666A" }}>
                      {/* No Skills Available */} N/A
                    </div>
                  ) : (
                    skills.map((skill, index) => {
                      return (
                        <div key={index}>
                          <div className="marketPlaceCardChip agent-skill-chip-drawer long-text-chip-css">
                            {skill}
                          </div>
                        </div>
                      );
                    })
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div >
    </>
  )
}

export default AgentClassification